<template>
	<div class="my-4">
		<p class="flex items-center gap-1 text-lg font-semibold italic">
			{{ t('document.offlineFormPrompt') }}
			<button
				:aria-label="t('document.offlineFormToggleLabel')"
				type="button"
				class="flex gap-1"
				@click="toggleForm"
			>
				<span class="text-primary-500 italic underline">
					{{ t('oap.sepioAppLink') }}
				</span>
				<ChevronRightIcon
					class="text-primary-500 h-6 w-6 text-xs"
					stroke-width="2"
					:class="{ 'rotate-90 transform': showForm }"
				/>
			</button>
		</p>
		<div
			v-if="showForm"
			class="w-full pb-8"
			:aria-label="t('document.offlineFormContainerLabel')"
		>
			<FormKit
				type="text"
				name="sepioMembershipNumber"
				:label="t('oap.sepioMembershipNumber')"
				outer-class="max-w-full! mt-9"
				input-class="h-8"
				inner-class="border! border-slate-300! rounded-lg"
				label-class="mb-2"
				validation="required"
				v-model="sepioMembershipNumber"
			/>
			<Teleport to="#oapEnrollmentNext">
				<button
					type="button"
					class="text-accent-700! h-12 w-60 justify-center self-end rounded-md border-0 font-extrabold transition-all duration-300"
					:class="
						valid
							? 'bg-accent-400! hover:bg-accent-500! hover:text-accent-800!'
							: 'bg-secondary-300! hover:bg-secondary-300! cursor-not-allowed text-slate-500/50! hover:text-slate-500/50!'
					"
					@click="handleNext"
				>
					{{ t('document.next') }}
				</button>
			</Teleport>
		</div>
	</div>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import { useSessionDocumentsStore } from '@/stores/sessionDocuments'
import { ChevronRightIcon } from '@heroicons/vue/24/outline'
import { computed, nextTick, ref } from 'vue'

const { t } = usePresentationLocale()
const showForm = ref(false)
const sessionDocumentsStore = useSessionDocumentsStore()

const sepioMembershipNumber = ref('')
const valid = computed(() => sepioMembershipNumber.value?.length > 0)

const handleNext = () => {
	if (valid.value) {
		sessionDocumentsStore.setOapStepTo('document')
	}
}

const toggleForm = async () => {
	showForm.value = !showForm.value
	if (showForm.value) {
		await nextTick()

		document.querySelector('#step-content-container')?.scrollTo({
			top: document.querySelector('#step-content-container')?.scrollHeight,
		})
	}
}
</script>
